import ScrollToHelper from '../../00_utilities/helpers/ScrollToHelper';

class Button {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        this.addSmoothScroll();
    }

    addSmoothScroll() {
        if (this.elem.classList.contains('button--scroll-to')) {
            this.elem.addEventListener('click', (event) => {
                event.preventDefault();

                const targetId = this.elem.getAttribute('href').replace('#', '');
                const anchorElement = document.getElementById(targetId);

                ScrollToHelper.scrollTo(anchorElement, 0);
            });
        }
    }
}

export default Button;
